import { MenuKeys } from '@/app/pages/home/constants/menuKeys';

// Customer features a shop owner can switch off (shop.disabledCustomerFeatures).
// Keys mirror optimo-crm-api/constants/customerFeatures.js — keep both in sync.
// `entitled` = the platform-level flag(s) the shop needs before the feature exists at all;
// a feature the shop is not entitled to is hidden from the settings tab (toggling it is a no-op).
export const CUSTOMER_FEATURE_GROUPS = [
  {
    id: 'shopping',
    labelKey: 'customer.feature.group.shopping',
    features: [
      { key: MenuKeys.PRODUCTS_AND_REWARDS, labelKey: 'default.menu.shop.reward', entitled: s => s.enableShoppingCart },
      { key: MenuKeys.SHOP_PRODUCTS, labelKey: 'default.menu.shop', entitled: s => s.enableShoppingCart },
      { key: MenuKeys.ORDER_HISTORY, labelKey: 'default.menu.order.history', entitled: s => s.enableShoppingCart },
      { key: MenuKeys.DEPOSIT, labelKey: 'default.menu.deposit', entitled: () => true }
    ]
  },
  {
    id: 'rewards',
    labelKey: 'customer.feature.group.rewards',
    features: [
      { key: MenuKeys.REWARDS, labelKey: 'default.menu.reward', entitled: s => s.enablePromotion },
      { key: MenuKeys.USER_PACKAGES, labelKey: 'default.menu.package', entitled: s => s.enablePackage },
      { key: MenuKeys.USER_COUPONS, labelKey: 'default.menu.coupon', entitled: s => s.enableCoupon },
      { key: MenuKeys.POINT_HISTORY, labelKey: 'default.menu.point.history', entitled: () => true }
    ]
  },
  {
    id: 'booking',
    labelKey: 'customer.feature.group.booking',
    features: [
      { key: MenuKeys.BOOKING, labelKey: 'default.menu.booking', entitled: s => s.isBooking },
      { key: MenuKeys.BOOKING2, labelKey: 'default.menu.booking2', entitled: s => s.isBooking2 }
    ]
  },
  {
    id: 'other',
    labelKey: 'customer.feature.group.other',
    features: [
      { key: MenuKeys.CUSTOMER_HISTORY, labelKey: 'menu.customer.history', entitled: () => true },
      { key: MenuKeys.CONTACT_US, labelKey: 'default.menu.contact', entitled: () => true }
    ]
  }
];

export const isCustomerFeatureEnabled = (shop, key) => !shop?.disabledCustomerFeatures?.includes(key);
